import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import {
    Box,
    Button,
    Grid,
    Hidden,
    Paper,
    IconButton,
    useMediaQuery,
} from '@mui/material';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import RestoreIcon from '@mui/icons-material/Restore';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ArchiveIcon from '@mui/icons-material/Archive';
import { styled } from '@mui/material/styles';
import React from 'react';
import {
    Link,
    Link as RouterNavLink,
    useLocation,
    useHistory,
} from 'react-router-dom';
import logo from '../../assets/airTeachr-Logo.png';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { ExitToApp, Login } from '@mui/icons-material';
const Header = styled('div')(({ theme }) => ({
    height: '80px',
    zIndex: '5',
    background: theme.palette.white.main,
    // height: '110px',
    width: '100%',
    position: 'fixed',
    top: 0,
    left: 0,
    // [theme.breakpoints.up('md')]: {
    //   width:`calc(100% - ${drawerWidth}px)`,
    //   marginLeft:`${drawerWidth}px`
    // }
    [theme.breakpoints.up('md')]: {
        display: 'none',
    },
}));

const Nav = styled('nav')(({ theme }) => ({
    display: 'flex',
    //height: '110px',
    height: '80px',
    alignItems: 'center',
    padding: '0 1rem',
}));

const MenuIconLarge = styled(MenuRoundedIcon)(({ theme }) => ({
    fontSize: 50,
    color: theme.palette.primary.main,
}));

const DivLogo = styled('div')(({ theme }) => ({
    marginLeft: '1rem',
}));

const ImgLogo = styled('img')(({ theme }) => ({
    maxHeight: '60px',
    [theme.breakpoints.up('lg')]: {
        width: '236px',
        height: '60px',
        marginLeft: '40px',
        marginTop: '10px',
        marginBottom: '10px',
    },
    [theme.breakpoints.down('md')]: {
        height: '50px',
        width: '212px',
    },
    [theme.breakpoints.only('xs')]: {
        height: '35px',
        width: '148px',
    },
}));

const LinkColor = styled(Link)(({ theme }) => ({
    color: theme.palette.primary.main,
    '&:hover': {
        color: theme.palette.secondary.main,
    },
}));

const DivSpacer = styled('div')(({ theme }) => ({
    flex: '1',
}));

const DivNavItems = styled('div')(({ theme }) => ({
    listStyle: 'none',
    margin: 0,
    padding: 0,
    display: 'flex',
}));

const DivToggle = styled('div')(({ theme }) => ({
    // marginRight: '15px',
    [theme.breakpoints.only('xs')]: {
        marginRight: '0px',
    },
    [theme.breakpoints.up('md')]: {
        display: 'none',
    },
}));

const BoxPadded = styled(Box)(({ theme }) => ({
    padding: '8px ',
}));

const Img = styled('img')(({ theme }) => ({
    width: '60px',
    height: '60px',
    boxShadow: '0 0 4px 0 #b3bac7',
    borderRadius: '20% !important',
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'block',
}));

const HideMenuLinks = styled(Grid)(({ theme }) => ({
    [theme.breakpoints.down('md')]: {
        display: 'none',
    },
}));

const BookingButton = styled(Button)(({ theme }) => ({
    margin: '5px',
    width: '150px',
    borderRadius: '30px',
}));
const ToolBar = props => {
    const location = useLocation();
    const history = useHistory();

    const isTabletAndAbove = useMediaQuery(theme => theme.breakpoints.up('md'));
    // log result
    //console.log("The username from ToolBar.js is " + props.state.username + " with an acronym of " + props.state.ackronym + " and a user type of " + props.state.type + ".");
    const pathnameSegments = location.pathname.split('/');

    // Check if the pathname has more than two segments
    const hasMoreThanTwoSegments = pathnameSegments.filter(
        item => item !== ''
    ).length;
    // console.log(hasMoreThanTwoSegments, 'hasMoreThanTwoSegments');
    const handleGoBack = () => {
        // Go back to the previous page in the browser history
        history.goBack();
    };
    return (
        <Header sx={{ display: 'none' }}>
            <Nav>
                {hasMoreThanTwoSegments >= 2 && !isTabletAndAbove ? (
                    <DivToggle>
                        {/*<MenuIconLarge onClick={props.handleDrawerToggleClick} />*/}
                        <IconButton
                            onClick={handleGoBack}
                            sx={{ marginLeft: '.51rem' }}
                            size="large"
                        >
                            <KeyboardBackspaceIcon
                                sx={{
                                    color: '#4632DA',
                                }}
                            />
                        </IconButton>
                    </DivToggle>
                ) : (
                    <Hidden only={['md', 'lg', 'xl']}>
                        <Link
                            tag={RouterNavLink}
                            to="/"
                            exact
                            activeclassname=""
                        >
                            <DivLogo>
                                <ImgLogo src={logo} alt="airTeachr logo" />
                            </DivLogo>
                        </Link>
                    </Hidden>
                )}

                <DivSpacer />

                <DivNavItems>
                    <HideMenuLinks
                        container
                        alignItems="center"
                        justifyContent="center"
                        display="none"
                    >
                        {!props.isAuthenticated && (
                            <>
                                {/* <Grid item>
                                    <BoxPadded>
                                        <LinkColor
                                            tag={RouterNavLink}
                                            to="/about"
                                            exact
                                            color="inherit"
                                        >
                                            About
                                        </LinkColor>
                                    </BoxPadded>
                                </Grid>
                                <Grid item>
                                    <BoxPadded>
                                        <LinkColor
                                            tag={RouterNavLink}
                                            to="/whyus"
                                            exact
                                        >
                                            Why Us?
                                        </LinkColor>
                                    </BoxPadded>
                                </Grid> */}
                                <Grid item>
                                    <BoxPadded>
                                        {/* <LinkColor
                                            tag={RouterNavLink}
                                            to="/signup"
                                            exact
                                            color="inherit"
                                        >
                                            Sign Up
                                        </LinkColor> */}
                                    </BoxPadded>
                                </Grid>
                            </>
                        )}
                        {props.isAuthenticated && (
                            <>
                                {props.profileExists > 0 ? (
                                    <>
                                        <Grid item>
                                            <BoxPadded>
                                                <LinkColor
                                                    tag={RouterNavLink}
                                                    to="/home"
                                                    exact
                                                >
                                                    Home
                                                </LinkColor>
                                            </BoxPadded>
                                        </Grid>
                                        {props.profileLoaded === 'succeeded' &&
                                            !props.schoolNoPermission && (
                                                <Grid item>
                                                    <BoxPadded>
                                                        <LinkColor
                                                            tag={RouterNavLink}
                                                            to="/action"
                                                            exact
                                                        >
                                                            Actions
                                                        </LinkColor>
                                                    </BoxPadded>
                                                </Grid>
                                            )}
                                        {props.profileLoaded === 'succeeded' &&
                                            !props.schoolNoPermission && (
                                                <Grid item>
                                                    <BoxPadded>
                                                        <LinkColor
                                                            tag={RouterNavLink}
                                                            to="/history"
                                                            exact
                                                        >
                                                            History
                                                        </LinkColor>
                                                    </BoxPadded>
                                                </Grid>
                                            )}

                                        {props.profile.type === 'School' &&
                                            props.schoolAdmin && (
                                                <>
                                                    <Grid item>
                                                        <BoxPadded>
                                                            <LinkColor
                                                                tag={
                                                                    RouterNavLink
                                                                }
                                                                to="/book-teacher"
                                                                exact
                                                            >
                                                                Book Teacher
                                                            </LinkColor>
                                                        </BoxPadded>
                                                    </Grid>
                                                    <Grid item>
                                                        <BoxPadded>
                                                            <LinkColor
                                                                tag={
                                                                    RouterNavLink
                                                                }
                                                                to="/casual-relief-teacher-list"
                                                                exact
                                                            >
                                                                Saved Teachers
                                                            </LinkColor>
                                                        </BoxPadded>
                                                    </Grid>
                                                    <Grid item>
                                                        <BoxPadded>
                                                            <LinkColor
                                                                tag={
                                                                    RouterNavLink
                                                                }
                                                                to="/schooljobs"
                                                                exact
                                                            >
                                                                School Jobs
                                                            </LinkColor>
                                                        </BoxPadded>
                                                    </Grid>
                                                </>
                                            )}
                                        {props.profile.type === 'Teacher' && (
                                            <>
                                                <Grid item>
                                                    <BoxPadded>
                                                        <LinkColor
                                                            tag={RouterNavLink}
                                                            to="/teacher-availability"
                                                            exact
                                                        >
                                                            Availability
                                                        </LinkColor>
                                                    </BoxPadded>
                                                </Grid>
                                                <Grid item>
                                                    <BoxPadded>
                                                        <LinkColor
                                                            tag={RouterNavLink}
                                                            to="/jobs"
                                                            exact
                                                        >
                                                            Jobs
                                                        </LinkColor>
                                                    </BoxPadded>
                                                </Grid>
                                            </>
                                        )}

                                        {/* <Grid item>
                                        {props.profileLoaded === 'succeeded' && (
                                            <BoxPadded>
                                                <LinkColor
                                                    tag={RouterNavLink}
                                                    to="/profile/userInfo"
                                                    exact
                                                    activeClassName="router-link-exact-active"
                                                >
                                                    <Img
                                                        src={
                                                            props.profile
                                                                .profileImage
                                                        }
                                                        alt="Profile"
                                                        width="50"
                                                    />
                                                </LinkColor>
                                            </BoxPadded>
                                        )}
                                    </Grid> */}
                                    </>
                                ) : (
                                    <Grid item>
                                        <BoxPadded>
                                            <LinkColor
                                                tag={RouterNavLink}
                                                to="/home"
                                                exact
                                            >
                                                Create Profile
                                            </LinkColor>
                                        </BoxPadded>
                                    </Grid>
                                )}
                            </>
                        )}
                    </HideMenuLinks>
                    {!props.isAuthenticated && (
                        <Grid
                            item
                            sx={{ display: { xs: 'none', sm: 'block' } }}
                        >
                            <BoxPadded sx={{ width: '260px' }}>
                                <LinkColor
                                    tag={RouterNavLink}
                                    to="/signup"
                                    exact
                                    color="inherit"
                                    sx={{ marginRight: '20px' }}
                                >
                                    Sign Up
                                </LinkColor>
                                <BookingButton
                                    onClick={() =>
                                        props.loginWithRedirect({
                                            scope: `${process.env.REACT_APP_scope} teacherProfile`,
                                            display: 'popup',
                                        })
                                    }
                                    variant="contained"
                                    color="primary"
                                    startIcon={<Login />}
                                    size="large"
                                >
                                    Login
                                </BookingButton>
                            </BoxPadded>
                        </Grid>
                    )}
                    {props.isAuthenticated && (
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            {props.profileExists > 0 && (
                                <Grid item>
                                    {props.profileLoaded === 'succeeded' && (
                                        <BoxPadded>
                                            <LinkColor
                                                tag={RouterNavLink}
                                                to="/profile/userInfo"
                                                exact
                                                activeClassName="router-link-exact-active"
                                            >
                                                {/*  <Img
                                                    src={
                                                        props.profile
                                                            .profileImage
                                                    }
                                                    alt="Profile"
                                                    width="50"
                                                />*/}
                                                {(hasMoreThanTwoSegments ===
                                                    1 ||
                                                    isTabletAndAbove) && (
                                                    <Img
                                                        src={
                                                            props.profile
                                                                .profileImage
                                                        }
                                                        alt="Profile"
                                                        width="50"
                                                    />
                                                )}
                                            </LinkColor>
                                        </BoxPadded>
                                    )}
                                </Grid>
                            )}
                            <Hidden only={['xs', 'sm', 'md', 'lg', 'xl']}>
                                <BoxPadded>
                                    <BookingButton
                                        onClick={() =>
                                            props.logout({
                                                returnTo:
                                                    window.location.origin,
                                            })
                                        }
                                        variant="contained"
                                        color="primary"
                                        startIcon={<ExitToApp />}
                                        size="large"
                                    >
                                        Log out
                                    </BookingButton>
                                </BoxPadded>
                            </Hidden>
                        </Box>
                    )}
                </DivNavItems>
            </Nav>
        </Header>
    );
};

export default ToolBar;
